const NavigatorModalLabels = {
  areYouSure: 'Are you sure?',
  confirmation: "Any unsaved changes will be lost. You won't be able to undo this.",
  decline: 'Take me back',
  accept: 'Yes, close',
};

export default NavigatorModalLabels;
